import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";
import { ForcedPasswordChange, PendingApproval } from "@/pages/AccountGate";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <CircleNotch size={28} className="animate-spin text-[#0033FF]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcedPasswordChange />;
  if (user.status === "pending") return <PendingApproval />;
  return children;
}
